import React, { useState } from "react";
import { useAnalyticsApi } from "react-use-analytics-api";

import { Box } from "@mui/material/";

import { AnalyticsDashboard, SessionsGeoChart } from "react-analytics-charts";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

const SessionGeo = ({ dashboard }) => {
  const [period, setPeriod] = useState(30);
  const { t, i18n } = useTranslation();

  const { ready, gapi, authorized, error } = useAnalyticsApi();
  let clientId =
    "568824200639-58enea0l8cr2arus6f1hech205ibqvci.apps.googleusercontent.com";
  let viewId = "261404142";

  return (
    <Box>
      {!dashboard && (
        <>
          <Box sx={{ pt: 3, pb: 1, fontSize: "22px" }}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {t("Geo Chart")}{" "}
            </span>
            <span className="pink_link"></span>
          </Box>
          <Box sx={{ pb: 1, color: "gray" }}>
            {t(
              "This GeoChart shows on a map of the world the number of sessions, and optionally pageviews, for each country, in the date range specified (number of days ago, until today). Useful for quickly visualizing where in the world your visitors are coming from."
            )}
          </Box>
        </>
      )}

      <FormControl sx={{ mt: 2, width: 300 }}>
        <InputLabel id="demo-simple-select-label">{t("Set Period")}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={period}
          label="Period"
          onChange={(e) => setPeriod(e.target.value)}
          sx={{ width: 300 }}
        >
          <MenuItem value={10}>10 {t("Days")}</MenuItem>
          <MenuItem value={30}>1 {t("Month")}</MenuItem>
          <MenuItem value={60}>3 {t("Month")}</MenuItem>
          <MenuItem value={180}>6 {t("Month")}</MenuItem>
          <MenuItem value={270}>9 {t("Month")}</MenuItem>
          <MenuItem value={365}>1 {t("Year")}</MenuItem>
        </Select>
      </FormControl>
      <AnalyticsDashboard
        authOptions={{ clientId }}
        renderCharts={(gapi, viewId) => {
          return (
            <SessionsGeoChart
              gapi={gapi}
              viewId={viewId}
              days={period}
              showPageViews
            />
          );
        }}
      />
    </Box>
  );
};

export default SessionGeo;
